<template>
  <div v-bind:style="computeCssFilter(buttonColor)">
    <slot></slot>
  </div>
</template>

<script>
import ColorUtils from "../utils/ColorUtils";

import Vue from "vue";

export default {
  mouted(){
    var mainUi = this.$store.getters['GET_MAIN_UI'];
  },
  computed: {
    mainColor : function(){

    },
    MainUISettings : function() {
      return  ;
    },
    buttonColor : function(){
      return this.$store.getters['GET_MAIN_UI'].button_color;
    },
  },
  methods : {
    computeCssFilter : function(hexColor){
      return new ColorUtils().convertHexToCssFilters(hexColor).filter;
    }
  }
};
</script>

<style>
</style>